const TOKEN_KEY = "user-token";

const setToken = value => {
  localStorage.setItem(TOKEN_KEY, value);
};
const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
};

const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
};
const hasToken = () => !!getToken();

export { setToken, getToken, removeToken, hasToken };
